// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"uY-z","subtitle":"vY-z","wrapper":"wY-z","leftArrow":"xY-z","rightArrow":"yY-z"};